import { Color } from '@persona-id/design-tokens';
import { SyntheticEvent } from 'react';
import styled from 'styled-components';

import Input from 'design-system/components/Input';

const Row = styled.div`
  margin-bottom: 12px;
  grid-column: 1 / 7;
`;

const DisplayInlineFormControl = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div`
  display: inline-block;
  user-select: none;
`;

const StyledInput = styled(Input)`
  width: 100px;
  height: 32px;
`;

const ErrorText = styled.span`
  color: ${Color.CoreRed700};
`;

const MinClusterSize = ({
  minClusterSize,
  onChange,
}: {
  minClusterSize: number;
  onChange: (n: number) => void;
}) => {
  const onMinClusterSizeChange = (e: SyntheticEvent<HTMLInputElement>) => {
    onChange(parseInt((e.target as HTMLInputElement).value) || 0);
  };

  const hasError = minClusterSize < 1;

  return (
    <Row>
      <DisplayInlineFormControl>
        <InputContainer>
          Only show clusters with at least{' '}
          <StyledInput
            onChange={onMinClusterSizeChange}
            value={minClusterSize ? minClusterSize.toString() : ''}
            hasError={hasError}
          />{' '}
          {minClusterSize === 1 ? 'node' : 'nodes'}
        </InputContainer>
        {hasError && <ErrorText>Number must be greater than 0</ErrorText>}
      </DisplayInlineFormControl>
    </Row>
  );
};

export default MinClusterSize;
